module.exports = __webpack_public_path__ + "img/Missing Stone.5da865ee.png";